import React, { ReactNode } from 'react'

import { MarginProps, MaxWidthProps } from 'styled-system'

import { Text } from 'Components/UI'

type Props = MarginProps &
  MaxWidthProps & {
    centered?: boolean
    inverse?: boolean
    text: ReactNode
  }

function PrimaryParagraph({ centered, inverse, text, ...rest }: Props) {
  return (
    <Text
      {...rest}
      body={!inverse}
      center={centered}
      inverse={inverse}
      regular
      screen20
    >
      {text}
    </Text>
  )
}

export default PrimaryParagraph
